import { ColumnsType } from "antd/es/table";
import IsDataNull from "../../Template/IsDataNull";
import { PackType } from "../../../utils/type";
import ActionColumnSettings from "./ActionColumnSetting";
import OrganizationLink from "./OrganizationLink";
import SortIcon from "../../SharedComponent/TableColumnComponent/SortIcon";

const UsersTableColumn: ColumnsType<PackType> = [
  {
    title: "User Name ",
    key: "username",
    dataIndex: "username",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: "Assigned Organizations ",
    key: "tenants",
    dataIndex: "tenants",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data, record) => (
      <OrganizationLink
        data={data}
        record={record}
      />
    ),
    width: 400,
  },
  {
    title: "Actions ",
    key: "actions",
    render: (data, record) => <ActionColumnSettings record={record} />,
    width: 130,
  },
];
//generic the data for the table

export default UsersTableColumn;
